import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { action, observable } from 'mobx';
var PlanStore = (function () {
    function PlanStore(rootStore) {
        var _this = this;
        this.rootStore = rootStore;
        this.plans = [];
        this.voipPlans = [];
        this.loading = true;
        this.planDetails = null;
        this.selectedPlanByType = {
            Business: '',
            Personal: '',
        };
        this.planCode = '';
        this.getInitialStoreState = function () { return ({
            formInitialValues: _this.getInitialFormValues(),
            formValues: null,
        }); };
        this.getInitialFormValues = function () { return ({
            accountNumber: '',
            address: '',
            contractCode: '',
            existingNumber: false,
            fullName: '',
            includeVoipBundle: false,
            numberToPort: '',
            planType: '',
            voipCode: '',
            voipCsgWaiverAccepted: false,
        }); };
        this.planDetails = this.getInitialStoreState();
    }
    PlanStore.prototype.setPlanCode = function (code) {
        this.planCode = code;
    };
    PlanStore.prototype.setPlanByType = function (type, code) {
        this.selectedPlanByType[type] = code;
    };
    PlanStore.prototype.setDetailsFromForm = function (details) {
        this.planDetails.formValues = details;
    };
    PlanStore.prototype.eligibleVoipPlans = function (contractCode) {
        var _this = this;
        return this.voipPlans
            .filter(function (voipPlan) {
            return _this.getContract(contractCode).voipCodes.includes(voipPlan.code.toString());
        })
            .sort(function (a, b) { return a.currentPricing.sellInc - b.currentPricing.sellInc; });
    };
    PlanStore.prototype.markLoading = function (loading) {
        this.loading = loading;
    };
    PlanStore.prototype.getEligibleNbnPlans = function () {
        var _this = this;
        return this.rootStore.checkAddressStore.contractCodes.length > 0
            ? this.plans.filter(function (plan) {
                return plan.serviceType.toLowerCase() === 'nbn' &&
                    _this.rootStore.checkAddressStore.contractCodes.includes(plan.code);
            })
            : this.plans.filter(function (plan) { return plan.serviceType.toLowerCase() === 'nbn'; });
    };
    PlanStore.prototype.getPlans = function () {
        var provider = this.rootStore.checkAddressStore.providerCode;
        if (provider === 'Uniti') {
            return this.plans.filter(function (p) { return p.planType && p.serviceType.toLowerCase() === 'uniti'; });
        }
        return this.plans.filter(function (p) { return p.planType && p.serviceType.toLowerCase() === 'nbn'; });
    };
    PlanStore.prototype.getEligibleVoipPlans = function () {
        return this.voipPlans;
    };
    PlanStore.prototype.loadPlans = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nbnPlans, unitiPlans, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.rootStore.api.V1.Lookup.Contracts.Broadband.Nbn()];
                    case 1:
                        nbnPlans = _a.sent();
                        return [4, this.rootStore.api.V1.Lookup.Contracts.Broadband.Uniti()];
                    case 2:
                        unitiPlans = _a.sent();
                        this.plans = nbnPlans.contracts.concat(unitiPlans.contracts);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        window.console.log(error_1);
                        return [3, 4];
                    case 4:
                        this.markLoading(false);
                        return [2];
                }
            });
        });
    };
    PlanStore.prototype.loadVoipPlans = function () {
        var _this = this;
        this.rootStore.api.V1.Lookup.Contracts.Voip()
            .then(function (r) {
            _this.voipPlans = r.contracts;
        })
            .catch(function (err) {
        });
        this.markLoading(false);
    };
    PlanStore.prototype.getContract = function (contractCode) {
        return this.plans.find(function (plan) { return plan.code === contractCode; });
    };
    PlanStore.prototype.getVoipContract = function (contractCode) {
        return this.voipPlans.find(function (plan) { return plan.code === contractCode; });
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PlanStore.prototype, "plans", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], PlanStore.prototype, "voipPlans", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], PlanStore.prototype, "loading", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], PlanStore.prototype, "planDetails", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], PlanStore.prototype, "selectedPlanByType", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], PlanStore.prototype, "planCode", void 0);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "setPlanCode", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "setPlanByType", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "setDetailsFromForm", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "eligibleVoipPlans", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "markLoading", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], PlanStore.prototype, "loadPlans", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PlanStore.prototype, "loadVoipPlans", null);
    __decorate([
        action,
        __metadata("design:type", Object)
    ], PlanStore.prototype, "getInitialStoreState", void 0);
    return PlanStore;
}());
export { PlanStore };
//# sourceMappingURL=PlanStore.js.map